export default __webpack_public_path__ + "static/logo-embaixada-3b75cefeaa4b1fb5a99550e521fa229a.png";